// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

import { useState } from 'react';
export const useVirtualElement = () => {
  const [virtualElement, setVirtualElement] = useState(null);
  const createVirtualElement = _ref => {
    let {
      clientX,
      clientY
    } = _ref;
    setVirtualElement({
      getBoundingClientRect() {
        return {
          width: 0,
          height: 0,
          x: clientX,
          y: clientY,
          left: clientX,
          right: clientX,
          top: clientY,
          bottom: clientY
        };
      }
    });
  };
  const resetVirtualElement = () => setVirtualElement(null);
  return [virtualElement, createVirtualElement, resetVirtualElement];
};